import React from 'react';
import { Link } from 'react-router-dom';
import { Row, Col } from 'react-bootstrap';

import { getCarSearchBrandsPath, getPassengerCarSearchPath } from 'helpers/intl';

export default class Start extends React.Component {
  render() {
    const { intl } = this.props;
    const messages = intl.messages;

    return [
      <Row className="no-margin select-funnel" key="1">
        <Col xs={12}>
          <div className="funnel-head">
            <h2>Wunschmodell wählen oder Fahrzeugangebot durchsuchen</h2>
          </div>
        </Col>
      </Row>,
      <Row className="no-margin select-funnel" key="2">
        <Col xs={12} sm={6} md={5} lg={4} mdOffset={1} lgOffset={2}>
          <Link to={getCarSearchBrandsPath()} className="text-master">
            <button className="select-funnel-btn full-width" type="button">
              <div className="select-funnel-btn-body">
                <div className="relative single-icon" style={{ height: '200px' }}>
                  <span>
                    <i className="chedri-sedan-car-model chedri-3x" />
                  </span>
                </div>
                <p className="small">Ich weiß schon genau die Marke und das Modell</p>
              </div>
            </button>

            <span className="select-funnel-btn-legend">Mein Modell wählen</span>
          </Link>
        </Col>

        <Col xs={12} sm={6} md={5} lg={4} className="sm-m-t-30">
          <Link to={getPassengerCarSearchPath()} className="text-master">
            <button className="select-funnel-btn full-width" type="button">
              <div className="select-funnel-btn-body">
                <div className="relative five-icons" style={{ height: '200px' }}>
                  <span>
                    <i className="chedri-car-city-model chedri-3x" />
                  </span>
                  <span>
                    <i className="chedri-car-suv chedri-3x" />
                  </span>
                  <span>
                    <i className="chedri-jeep chedri-3x" />
                  </span>
                  <span>
                    <i className="chedri-sportive-car chedri-3x" />
                  </span>
                  <span>
                    <i className="chedri-cabrio-car chedri-3x" />
                  </span>
                </div>
                <p className="small">Helft mir bei der Suche nach dem besten Modell für mich</p>
              </div>
            </button>

            <span className="select-funnel-btn-legend">Passendes Modell finden</span>
          </Link>
        </Col>
      </Row>,
    ];
  }
}
